import React from "react";
import { SearchOff as SearchOffIcon } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import EmptyState from "../../common/EmptyState";

interface NoFreelancersFoundProps {
	onClearFilters: () => void;
}

const NoFreelancersFound: React.FC<NoFreelancersFoundProps> = ({ onClearFilters }) => {
	const { t } = useTranslation();

	return (
		<EmptyState
			icon={
				<SearchOffIcon
					sx={{
						fontSize: 60,
						color: "white"
					}}
				/>
			}
			title={t("components.noTalentsFound.title")}
			message={t("components.noTalentsFound.message")}
			iconBackgroundGradient="linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
			iconBoxShadow="0 10px 30px rgba(102, 126, 234, 0.3)"
			onRetry={onClearFilters}
			retryButtonText={t("components.noTalentsFound.clearFiltersButton")}
		/>
	);
};

export default NoFreelancersFound;
